module.exports = __webpack_public_path__ + "static/media/logo.f341237c.jpg";